import EtherscanStyleTxDetails from '../components/transaction/EtherscanStyleTxDetails';
import { useSolanaTransaction } from '../hooks/useSolanaTransaction';

function SolanaTransactionDetailsView({ signature }) {
  const { data, loading, error } = useSolanaTransaction(signature);

  return (
    <EtherscanStyleTxDetails
      display={data?.display}
      loading={loading}
      error={error}
      title="Transaction Details"
    />
  );
}

export default SolanaTransactionDetailsView;
